module.exports = require('./CheckCasherApplicationView');
